module.exports = require('./CheckCasherApplicationView');
